var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Events.less');

var EventsList = require('front/components/EventsList/EventsList');
var AdvertisingBanner = require('front/components/AdvertisingBanner/AdvertisingBanner');

module.exports = Section.extend({

    el: '.Events',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AdvertisingBanner': {selector: '.AdvertisingBanner', viewConstructor: AdvertisingBanner},
        'EventsList': {selector: '.EventsList', viewConstructor: EventsList}
    },

    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'scrollToListFromUrl');

        Section.prototype.initialize.call(this, options);
    },


    activate: function () {
        this.scrollToListFromUrl();

        $(window).on('hashchange', this.scrollToListFromUrl);

        return Section.prototype.activate.call(this);
    },


    deactivate: function (params) {
        $(window).off('hashchange', this.scrollToListFromUrl);

        return Section.prototype.deactivate.call(this, params);
    },


    scrollToListFromUrl: function (e) {
        var hash = location.hash.slice(1);

        if (!hash) return;

        var anchorList = {
            'figure-drawing-workshop': 1,
            'gallery-800': 2,
            'film-society': 3,
            'adg-awards': 4,
            'comic-con': 5
        };

        var id = anchorList[hash];

        if (!id) return;

        var $list = this.$('.EventsList[data-id="' + id + '"]');

        if (!$list.length) {
            app.animateWindowScroll(0);
        } else {
            if (e) {
                app.animateWindowScroll($list.offset().top - 70);
            } else {
                setTimeout(function () {
                    app.animateWindowScroll($list.offset().top - 70);
                }, 300);
            }
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Events/Events.js
// module id = 260
// module chunks = 0